export const messages = {
    "wre-dashboard.nav-menu.item.shared": "공유",
    "wre-dashboard.nav-menu.item.backups": "백업",
    "wre-dashboard.nav-menu.item.machines": "머신",
    "wre-dashboard.nav-menu.item.account": "계정",
    "wre-dashboard.search.input.hint": "검색",
    "wre-dashboard.search.label.breadcrumb": "검색 결과",
    "wre-dashboard.search.message.empty": "검색과 일치하는 항목이 없습니다",
    "wre-dashboard.side-bar.selected.title:plural": "{count}개 항목 선택됨 | {count}개 항목 선택됨",
    "wre-dashboard.side-bar.backup-type.disk": "디스크",
    "wre-dashboard.side-bar.backup-type.file": "파일",
    "wre-dashboard.side-bar.backup-type.notarized": "공증된 파일과 폴더",
    "wre-dashboard.side-bar.backup-type.exchange": "애플리케이션 - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "애플리케이션 - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "애플리케이션 - 시스템 상태",
    "wre-dashboard.side-bar.backup-type.application": "응용 프로그램",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} 남음",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} 사용됨",
    "wre-dashboard.space-indicator.label.unlimited": "제한 없음",
    "wre-dashboard.backups-table.column.name": "이름",
    "wre-dashboard.backups-table.column.size": "크기",
    "wre-dashboard.backups-table.column.version": "마지막 백업",
    "wre-dashboard.backups-table.message.no-backups": "클라우드에 아직 백업이 없습니다",
    "wre-dashboard.backups-sidebar.label.size": "크기",
    "wre-dashboard.backups-sidebar.label.type": "유형",
    "wre-dashboard.backups-sidebar.label.version": "마지막 버전",
    "wre-dashboard.backups-sidebar.label.created": "생성됨",
    "wre-dashboard.backups-sidebar.label.machine": "머신",
    "wre-dashboard.backups-sidebar.label.owner": "소유자",
    "wre-dashboard.content-table.column.name": "이름",
    "wre-dashboard.content-table.column.versions": "버전",
    "wre-dashboard.content-table.column.volumes": "볼륨",
    "wre-dashboard.content-table.column.path": "경로",
    "wre-dashboard.content-table.column.size": "크기",
    "wre-dashboard.content-table.column.version": "마지막 버전",
    "wre-dashboard.content-table.action.versions": "버전",
    "wre-dashboard.content-table.action.restore": "다운로드",
    "wre-dashboard.content-table.action.share": "공유 링크",
    "wre-dashboard.content-table.label.size": "크기",
    "wre-dashboard.content-table.label.created": "생성됨",
    "wre-dashboard.content-table.label.modified": "수정",
    "wre-dashboard.content-table.message.empty-folder": "이 폴더가 비어 있습니다",
    "wre-dashboard.password-dialog-box.title.backup": "암호화된 백업",
    "wre-dashboard.password-dialog-box.title.archive": "암호화된 아카이브",
    "wre-dashboard.password-dialog-box.message.backup": "백업 {displayName}에 액세스하기 위한 비밀번호를 지정하십시오",
    "wre-dashboard.password-dialog-box.message.archive": "아카이브 {displayName}에 액세스하기 위한 비밀번호를 지정하십시오",
    "wre-dashboard.password-dialog-box.hint.password": "암호",
    "wre-dashboard.password-dialog-box.message.invalid-password": "비밀번호가 잘못되었습니다",
    "wre-dashboard.form.button.open": "열기",
    "wre-dashboard.form.button.close": "닫기",
    "wre-dashboard.form.button.cancel": "취소",
    "wre-dashboard.form.button.delete": "삭제",
    "wre-dashboard.shared-content-table.column.name": "이름",
    "wre-dashboard.shared-content-table.column.location": "위치",
    "wre-dashboard.shared-content-table.column.source": "소스",
    "wre-dashboard.shared-content-table.column.days": "일",
    "wre-dashboard.shared-content-table.column.downloads": "다운로드",
    "wre-dashboard.shared-content-table.column.shared": "공유 위치",
    "wre-dashboard.shared-content-table.label.shared": "공유 위치",
    "wre-dashboard.shared-content-table.label.backup": "소스",
    "wre-dashboard.shared-content-table.action.share": "공유 링크",
    "wre-dashboard.shared-content-table.action.settings": "링크 설정",
    "wre-dashboard.shared-content-table.action.delete": "링크 삭제",
    "wre-dashboard.shared-content-table.action.delete-selected": "링크 삭제",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} / {totalSpace} 남음",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: 무제한 공간",
    "wre-dashboard.account-page.button.sign-out": "로그아웃",
    "wre-dashboard.account-page.button.manage-subscription": "라이센스 관리",
    "wre-dashboard.account-page.message.subscription.active": "{brandName} 공간에 대한 사용자의 라이센스 만료일:",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} 평가판 활성화 종료일:",
    "wre-dashboard.account-page.message.subscription.expired": "{brandName} 공간에 대한 사용자의 라이센스 만료일:",
    "wre-dashboard.account-page.message.worm-status.storage-full": "{brandName} 스토리지가 가득 찼습니다. 클라우드에 데이터를 백업하거나 아카이브할 수 없습니다.",
    "wre-dashboard.account-page.message.worm-status.less-than": "남은 공간이 {percent}% 미만입니다. 곧 {brandName}을(를) 사용할 수 없게 됩니다.",
    "wre-dashboard.versions-dialog-box.title": "{fileName} 버전",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "링크 복사",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "링크 설정",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "이 링크를 사용하는 모두가 최근 버전의 데이터를 볼 수 있습니다",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "{creationDate}에서 공유됨",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "링크 복사됨",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "링크 복사 오류",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "링크 삭제",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "이 링크는 더 이상 아무도 사용할 수 없습니다",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "링크 삭제",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "이 링크를 가진 모두에게 링크의 작동이 중단됩니다.",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "링크 설정",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "링크 삭제",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "완료",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "암호",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "패스워드 재설정",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "비밀번호 보호",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "비밀번호를 사용해 이 링크를 보호하십시오",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "만료",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "다운로드 제한",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "{splitMarker}일 후 이 링크 비활성화 | {splitMarker}일 후 이 링크 비활성화",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "{splitMarker}번 다운로드 후 이 링크 비활성화 | {splitMarker}번 다운로드 후 이 링크 비활성화",
    "wre-dashboard.sub-accounts-dialog-box.title": "계정",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "검색",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "검색과 일치하는 항목이 없습니다",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "이름",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "사용",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "마지막 백업",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "만료",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} 여유 공간 {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "대량 가입",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "만료됨",
    "wre-dashboard.machines-table.column.name": "이름",
    "wre-dashboard.machines-table.column.size": "크기",
    "wre-dashboard.machines-table.message.no-machines": "클라우드에 아직 머신이 없습니다"
};
